import { rmdIcons } from "./rmdIcons";

export const rmdCollections = {
    rmd: rmdIcons
};